/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { SetStateAction } from 'react';
import { Icon } from '@blueprintjs/core';
import { ProgressBar as FormProgressBar } from './ProgressBar.js';

import { ColorProps, DefinitionProps } from '../interfaces';
import { SchemaEditor } from '/views/datasetManagement/schemaEditor.js';

export const Schema: React.FC<SchemaProps> = ({ dil, setDil, colors, setStep }) => {

	const returnToFileUpload: React.ReactElement = (
		<div
			css={{ display: 'inline', cursor: 'pointer', color: colors.text }}
			onClick={(e) => {
				e.preventDefault();
				setStep('Upload File');
				window.location.reload(false); 
            }}
            key="return-to-upload"
		>
			<Icon icon="chevron-left" iconSize={16} />
			Return to File Upload
		</div>
	);

	return (
		<div css={divCss}>
			<FormProgressBar step={1} />
			<div css={containerCss}>
				<div css={{ paddingBottom: 10 }}>
					<h3>Schema Editor</h3>
					<p css={{ color: colors.text }}>
						We looked through your data and attached this schema. Edit anything that doesn’t look right and hit “Done”.{' '}
					</p>
					<hr />
				</div>
				<SchemaEditor
					dil={dil}
					setDil={setDil}
					colors={colors}
					onComplete={() => setStep('Done')}
					additionalfooterContent={returnToFileUpload}
				/>
			</div>
		</div>
	);
};

interface SchemaProps {
	colors: ColorProps;
	dil: DefinitionProps;
	setDil: React.Dispatch<SetStateAction<DefinitionProps>>;
	setStep: React.Dispatch<SetStateAction<string>>;
}

const divCss = css`
	flex: 1 1 auto;
	overflow: hidden;
	display: flex; 
	flex-direction: column; 	
`; 

const containerCss = css`
	padding: 25px 40px;
	flex: 1 1 auto;
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;
